import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// styles
import styles from './PdpRespIconBubbles.scss';

// Components
import PdpSharedIconBubblePinterest from '../PdpSharedIconBubbles/PdpSharedIconBubblePinterest';
import PdpSharedIconBubbleFacebook from '../PdpSharedIconBubbles/PdpSharedIconBubbleFacebook';
import PdpSharedIconBubbleEmail from '../PdpSharedIconBubbles/PdpSharedIconBubbleEmail';
import PdpRespIconBubblePrint from './PdpRespIconBubblePrint';

function PdpRespIconBubbles(props) {
    const { item, user, viewer } = props;

    return (
        <div className={styles.wrapper}>
            {viewer.isPinterestShareEnabled && <PdpSharedIconBubblePinterest item={item} />}
            {viewer.isFacebookShareEnabled && <PdpSharedIconBubbleFacebook item={item} />}
            <PdpSharedIconBubbleEmail item={item} user={user} viewer={viewer} />
            <PdpRespIconBubblePrint />
        </div>
    );
}

PdpRespIconBubbles.propTypes = {
    viewer: PropTypes.object.isRequired,
    item: PropTypes.object.isRequired,
    user: PropTypes.object,
};

export default createFragmentContainer(PdpRespIconBubbles, {
    viewer: graphql`
        fragment PdpRespIconBubbles_viewer on Viewer {
            ...PdpSharedIconBubbleEmail_viewer
            isPinterestShareEnabled: isEnabledByLocale(featureName: "PINTEREST_SHARE")
            isFacebookShareEnabled: isEnabledByLocale(featureName: "FACEBOOK_SHARE")
        }
    `,
    item: graphql`
        fragment PdpRespIconBubbles_item on Item {
            ...PdpSharedIconBubblePinterest_item
            ...PdpSharedIconBubbleFacebook_item
            ...PdpSharedIconBubbleEmail_item
        }
    `,
    user: graphql`
        fragment PdpRespIconBubbles_user on User {
            ...PdpSharedIconBubbleEmail_user
        }
    `,
});
